export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15120.483d7bc9.jpg";